import { useEffect, useRef, useState } from 'react'
import { useScroll, useTransform } from 'framer-motion'

import { config } from 'config'
import { Bubble } from './bubble'
import { ImageDetail } from './image-detail'
import {
  Date,
  Description,
  Hint,
  Item,
  Link,
  Links,
  ListContainer,
  ScrollInner,
  ScrollingContent,
  Section,
  Text,
  TimelineList,
  Title,
} from './styled'
import { timeline } from 'lang/timeline'
import { resizeGdbImage } from 'utils'
import { useAppContext } from 'context/app-context'

export const Timeline = () => {
  const { strings } = useAppContext()
  const [fullImageUrl, setFullImageUrl] = useState('')
  const ref = useRef(null)
  const contentRef = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start start', 'end end'],
  })
  const clampedProgress = useTransform(scrollYProgress, [0.1, 0.95], [0, 1], {
    clamp: true,
  })

  useEffect(() => {
    clampedProgress.on('change', v => {
      if (contentRef.current) {
        const multiplier =
          document.documentElement.getAttribute('dir') === 'rtl' ? -1 : 1
        contentRef.current.scrollLeft =
          contentRef.current.scrollWidth * v * multiplier
      }
    })
  }, [])

  useEffect(() => {
    if (fullImageUrl) {
      document.documentElement.classList.add('locked')
    } else {
      document.documentElement.classList.remove('locked')
    }
  }, [fullImageUrl])

  return (
    <Section ref={ref}>
      <Title>{strings.timeline.title}</Title>
      <Hint>{strings.timeline.hint}</Hint>

      <ScrollingContent ref={contentRef}>
        <ScrollInner>
          <ListContainer>
            <TimelineList>
              {timeline
                .filter(item => !!item[config.language])
                .map(({ image, ...item }) => ({
                  image,
                  ...item[config.language],
                }))
                .map((item, i) => (
                  <Item
                    $position={i % 2 ? 'bottom' : 'top'}
                    key={i}
                    onClick={evt => {
                      if (
                        (evt.target as Element).localName !== 'a' &&
                        item.image
                      ) {
                        setFullImageUrl(item.image)
                      }
                    }}
                  >
                    <Text>
                      <Date>{item.date}</Date>
                      <Description>{item.description}</Description>
                      {!!item.links && (
                        <Links>
                          {item.links.map((link, n) => (
                            <Link href={link.url} key={n} target="_blank">
                              {link.label}
                            </Link>
                          ))}
                        </Links>
                      )}
                    </Text>
                    <Bubble
                      $position={i % 2 ? 'bottom' : 'top'}
                      src={item.image ? resizeGdbImage(item.image, 400) : ''}
                    />
                  </Item>
                ))}
            </TimelineList>
          </ListContainer>
        </ScrollInner>
      </ScrollingContent>

      <ImageDetail url={fullImageUrl} onClose={() => setFullImageUrl('')} />
    </Section>
  )
}
